import isServer from '../env/is-server';
import { NextRequest } from 'next/server';
/**
 * 获取UserAgent
 * @param ctx
 */
export default function getNextUserAgent(ctx?: any, req?: NextRequest) {
  let userAgent;

  if (isServer) {
    if (req) {
      userAgent = req?.ua?.ua;
    } else {
      userAgent = ctx?.req?.headers['user-agent'] || '';
    }
  } else {
    userAgent = window.navigator.userAgent;
  }

  return userAgent || '';
}
